import { useEffect, useState } from "react";

import { getData, generateProfitabilityData } from "../../../../../services";
import {
  NALabel,
  HighEconomicLabel,
  HighPhysicalLabel,
  ProfitabilityOverTime,
} from "../../../../../components/parts";

const defaultProfitabilityOverTime = {
  chart_data: [],
  reference_areas: [],
};

export const ProfitabilityOverTimeComponent = ({ buildingId, complexId }) => {
  const [profitabilityOverTime, setProfitabilityOverTime] = useState(defaultProfitabilityOverTime);

  let url = `/praas/v2/buildings/properties/profitability-graph/`;
  let title = `Portfolio Revenues Over Time`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/profitability-graph/`;
    title = `Building Profitability Over Time`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/profitability-graph/`;
    title = `Complex Profitability Over Time`;
  }

  useEffect(() => {
    getData(url, (results) => {
      const { chartData, economicXAxisGroups, physicalXAxisGroups, emptyXAxisGroups } =
        generateProfitabilityData(results);

      const referenceAreas = [];
      economicXAxisGroups.forEach((group) => {
        if (group.length >= 2) {
          referenceAreas.push({
            dataKey: "index",
            x1: group[0],
            x2: group[group.length - 1],
            label: <HighEconomicLabel />,
          });
        }
      });
      physicalXAxisGroups.forEach((group) => {
        if (group.length >= 2) {
          referenceAreas.push({
            dataKey: "index",
            x1: group[0],
            x2: group[group.length - 1],
            label: <HighPhysicalLabel />,
          });
        }
      });
      emptyXAxisGroups.forEach((group) => {
        if (group.length > 1) {
          referenceAreas.push({
            dataKey: "index",
            x1: group[0],
            x2: group[group.length - 1],
            label: <NALabel />,
          });
        }
      });

      setProfitabilityOverTime({
        chart_data: chartData,
        reference_areas: referenceAreas,
      });
    });
  }, [buildingId, complexId]);

  return (
    <ProfitabilityOverTime
      title={title}
      buttonText="Optimize Tenants Profitability"
      onClick={() => null}
      chartData={profitabilityOverTime.chart_data}
      referenceAreas={profitabilityOverTime.reference_areas}
    />
  );
};
